<app-loader [enable]="loader && !rowData.length || resizeLoader">
  <div class="relative full-height" @enterLeaveTableOpacity>
    <ag-grid-angular
      #agGrid
      class="ag-grid ag-theme-material"
      [pagination]="pagination"
      [paginationPageSize]="paginationPageSize$ | async"
      [cacheBlockSize]="paginationPageSize$ | async"
      [maxBlocksInCache]="1"
      [suppressPropertyNamesCheck]="true"
      [suppressPaginationPanel]="false"
      [rowData]="rowData"
      [rowBuffer]="rowBuffer"
      [columnDefs]="columnDefs"
      [tooltipShowDelay]="0"
      [defaultColDef]="defaultColDef"
      [pinnedBottomRowData]="pinnedBottomRowData"
      [frameworkComponents]="frameworksComponents"
      [rowClassRules]="rowClassRules"
      [gridOptions]="gridOptions"
      [localeText]="localeText"
      [rowModelType]="rowModelType"
      [serverSideStoreType]="serverSideStoreType"
      [serverSideDatasource]="serverSideDataSource"
      [loadingOverlayComponentParams]="loadingOverlayComponentParams"
      [noRowsOverlayComponentParams]="noRowsOverlayComponentParams"
      [overlayNoRowsTemplate]="overlayNoRowsTemplate"
      [overlayLoadingTemplate]="overlayLoadingTemplate"
      [loadingOverlayComponent]="loadingOverlayComponent"
      [noRowsOverlayComponent]="noRowsOverlayComponent"
      [modules]="modules"
      [getContextMenuItems]="getContextMenuItems"
      [enableRangeSelection]="enableRangeSelection"
      [processCellForClipboard]="processCellForClipboard"
      [suppressContextMenu]="suppressContextMenu"
      [clipboardDeliminator]="clipboardDeliminator"
      [isExternalFilterPresent]="isExternalFilterPresent"
      [doesExternalFilterPass]="doesExternalFilterPass"
      [suppressColumnVirtualisation]="true"
      (firstDataRendered)="onFirstDataRendered($event)"
      (modelUpdated)="onModelUpdated($event)"
      (filterModified)="onFilterChanged($event)"
      (gridReady)="onGridReady($event)"
      (columnEverythingChanged)="columnEverythingChanged($event)"
      (rowClicked)="rowClickedE.emit($event)"
      (columnMoved)="columnMovedE.emit($event)"
      (dragStopped)="dragStoppedE.emit($event)"
      (sortChanged)="sortChangedE.emit($event)"
      (filterChanged)="filterChangedE.emit($event)"
      (rowDataChanged)="rowDataChanged($event)"
      (columnPinned)="columnPinnedE.emit($event)"
      (columnResized)="columnResizedE.emit($event)"
      (paginationChanged)="onPaginationChanged($event)"></ag-grid-angular>
      <app-select id="nbRowsSelector"
                  [control]="nbRowsCtrl"
                  keyText="text"
                  [valueGetter]="nbRowsValueGetter"
                  [disableSort]="true"
                  [options]="nbRowsOptions"
                  *ngIf="(paginationPageSize$ | async) && pagination"></app-select>
  </div>
</app-loader>
